<template>
  <v-autocomplete
    v-bind="$attrs"
    :items="availableItems"
    :label="label"
    v-model="selected"
    :item-text="itemText"
    item-value="ID"
    :clearable="clearable"
    :rules="rules"
    chips
    deletable-chips
    multiple
    dense
    :loading="loading"
    :search-input.sync="searchInput"
    @change="searchInput=''"
  ></v-autocomplete>
</template>
<script>
  import { get, sync, commit, call } from 'vuex-pathify'
  export default {
    name: 'autocomplete-multi-id-LuCOGEntityType',
    model: {
      prop: 'value',
      event: 'change',
    },
    props: {
      label: {
        type: String,
        default: 'Lu C O G Entity Type',
        },
      value: Array,
      clearable: {
        type: Boolean,
        default: false,
      },
      rules: Array,
    },
    data(){
      return {
        // if there is more than one pick one to display
        itemText: 'Description',
        searchInput: '',
      }
    },
    watch: {
      value(nval, oval) {
        if (nval != oval) {
          this.searchInput = ''
        }
      },
    },
    computed: {
      ...get('luCogEntityType',['luCOGEntityType', 'loading']),
      availableItems() {
          //if you have a property (like an IsActive boolean) you can change the true to filer i.e. i.IsActive
          var list = this.luCOGEntityType.filter((i) => true )
          list = list.filter((i) => i.IsActive )
          // if existing record make sure the previous selection is available even if no longer active
          if (this.value > 0) {
            var selectedItem = this.luCOGEntityType.find((i) => i.ID == this.value)
            if (selectedItem && !list.find((i) => i.ID == this.value) && selectedItem) {
              list.push(selectedItem)
            }
          }
          // sort by column
          list.sort((a, b) => {
            //set the property to sort on
            let textField = this.itemText
            let sort = a[textField] > b[textField] ? 1 : -1
            return sort
          })
          return list
      },
      selected: {
        get() {
          if (this.value && this.value.length > 0) {
            return this.value
          } else {
            return []
          }
        },
        set(newValue) {
          this.$emit('change', newValue)
        }
      }
    },
    created(){
      this.loadLuCOGEntityType()
    },
    methods: {
      loadLuCOGEntityType: call('luCogEntityType/loadLuCOGEntityType'),
    },
  }
</script>
<style>

</style>